import { Action } from 'redux';

import { NewPredictiveModelForDatasource } from '../../bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '../../bootstrap/redux/actions/isActionFactory';
import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';

export interface NewPredictiveModelForDatasourceAction extends Action {
  contentInfo: IContentInfo;
}

export function newPredictiveModelForDatasource(contentInfo: IContentInfo): NewPredictiveModelForDatasourceAction {
  return {
    type: NewPredictiveModelForDatasource,
    contentInfo
  };
}

export const isNewPredictiveModelForDatasourceAction = isActionFactory<NewPredictiveModelForDatasourceAction>(NewPredictiveModelForDatasource);
